import { PerfilType } from 'src/@types';
import { Permission } from 'src/constants/Permission';
import PAGES from 'src/pageTree';

export function hasPermissions({
  perfil,
  permissions,
}: {
  perfil?: PerfilType | null;
  permissions?: Permission[] | keyof typeof PAGES | null;
}) {
  if (!perfil) {
    return false;
  }

  const permissionsArray = !permissions
    ? null
    : Array.isArray(permissions)
      ? permissions
      : PAGES[permissions].permission;

  if (!permissionsArray || perfil.is_superadmin) {
    return true;
  }

  for (const permission of permissionsArray) {
    if (permission in perfil && perfil[permission]) {
      return true;
    }
  }

  return false;
}
